import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';

export function Searches() {
  const navigate = useNavigate();
  const accessCustomKpi = useAppStore((state) => state.accessCustomKpi);

  useEffect(() => {
    document.title = 'Searches | SimplyScrapable';
  }, []);

  return (
    <div className="min-h-screen bg-dark-bg text-white">
      <div className="max-w-6xl mx-auto px-6 py-10 space-y-8">
        <div>
          <h1 className="text-3xl font-bold">Searches</h1>
          <p className="text-gray-400 mt-2">
            Choose the search type that fits your goal. Contact Search is for people. Company Search is for businesses.
            Scrappy Guided Search turns plain English into filters. Custom KPI Search is for hard-to-find company criteria.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <div className="bg-card-dark border border-border-dark rounded-xl p-6 flex flex-col gap-4">
            <div>
              <h2 className="text-xl font-semibold">Contact Search</h2>
              <p className="text-sm text-gray-400 mt-2">
                Find decision makers by title, seniority, department, company, or location.
              </p>
            </div>
            <button
              onClick={() => navigate('/lead-search')}
              className="mt-auto px-4 py-2 rounded bg-red-600 hover:bg-red-500 text-white font-semibold"
            >
              Open Contact Search
            </button>
          </div>

          <div className="bg-card-dark border border-border-dark rounded-xl p-6 flex flex-col gap-4">
            <div>
              <h2 className="text-xl font-semibold">Company Search</h2>
              <p className="text-sm text-gray-400 mt-2">
                Discover companies by industry, size, location, and signals before digging into contacts.
              </p>
            </div>
            <button
              onClick={() => navigate('/company-search')}
              className="mt-auto px-4 py-2 rounded bg-red-600 hover:bg-red-500 text-white font-semibold"
            >
              Open Company Search
            </button>
          </div>

          <div className="bg-card-dark border border-border-dark rounded-xl p-6 flex flex-col gap-4">
            <div>
              <h2 className="text-xl font-semibold">Scrappy Guided Search</h2>
              <p className="text-sm text-gray-400 mt-2">
                Describe your ICP in plain language. Scrappy asks only missing questions, then runs normal Contact Search.
              </p>
            </div>
            <button
              onClick={() => navigate('/scrappy')}
              className="mt-auto px-4 py-2 rounded bg-red-600 hover:bg-red-500 text-white font-semibold"
            >
              Open Scrappy
            </button>
          </div>

          <div className="bg-card-dark border border-border-dark rounded-xl p-6 flex flex-col gap-4">
            <div>
              <h2 className="text-xl font-semibold">Custom KPI Search</h2>
              <p className="text-sm text-gray-400 mt-2">
                Find companies with specific, hard-to-identify criteria and custom KPIs.
              </p>
            </div>
            <button
              onClick={() => navigate('/custom-kpi-search')}
              disabled={!accessCustomKpi}
              className={`mt-auto px-4 py-2 rounded text-white font-semibold ${
                accessCustomKpi ? 'bg-red-600 hover:bg-red-500' : 'bg-gray-700 cursor-not-allowed'
              }`}
            >
              {accessCustomKpi ? 'Open Custom KPI Search' : 'Upgrade Required'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
